import styles from "./RatingsCompact.module.scss";

interface RatingsCompactProps {
  averageRating: number;
}

export const RatingsCompact = ({ averageRating }: RatingsCompactProps) => {
  return (
    <div
      className={styles.ratingsCompact}
      role="img"
      aria-label={`Rated ${averageRating.toFixed(1)} out of 5 stars`}
    >
      <span aria-hidden="true">
        {averageRating.toFixed(1)}
        <span className={styles.starRated}></span>
      </span>
    </div>
  );
};
